import { Component, input } from '@angular/core';
import { FaIconComponent, TitleComponent } from '@akostm/orbit-ui';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'orbit-title-bar',
  standalone: true,
  imports: [CommonModule, TitleComponent],
  templateUrl: './title-bar.component.html',
  styleUrl: './title-bar.component.scss',
})
export class TitleBarComponent {
  // public iconClass = input.required<string>();
  // public textColor = input<string | undefined>(undefined);
  public titleValue = input.required<string>();
  public backgroundColor = input<string>('var(--background-color)');
  // public size = input<'lg' | 'md' | 'sm' >('md');
}
